// extracted by mini-css-extract-plugin
export default {"image":"reflections_image__qPPRH","body":"reflections_body__5rwZl"};